/**
 * Liste figée au 1er octobre 2026 (décision n° 4 du plan directeur), sans le
 * service `site` depuis le 27 octobre 2026 : le dirigeant le retire de tout
 * espace qui n'a pas commandé et réglé un site fait par Artosera. Un service
 * n'est donc jamais accordé par cette liste commune ; seule une galerie du jeu
 * qui l'a acheté dans la fiction l'ouvre, nommément.
 * Un module livré plus tard n'entre dans le jeu de démonstration que par
 * décision écrite ; cette liste ne suit pas la disponibilité du registre.
 */
export const MODULES_DEMONSTRATION = [
    'facturation',
    'coffre',
    'mode-foire',
    'documents-prestige',
    'editions-provenance',
    'roles-fins',
    'api-comptabilite',
];
export function estModuleDemonstration(valeur) {
    return MODULES_DEMONSTRATION.includes(valeur);
}
//# sourceMappingURL=demonstration.js.map